export const BACKSPACE_KEY_CODE = 8
export const DELETE_KEY_CODE = 46
export const ENTER_KEY_CODE = 13
export const LEFT_ARROW = 37
export const UP_ARROW = 38
export const RIGHT_ARROW = 39
export const DOWN_ARROW = 40
